import { render } from "./LotMatcher.vue?vue&type=template&id=4ca1b496&scoped=true&ts=true&lang=pug"
import script from "./LotMatcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotMatcher.vue?vue&type=script&lang=ts&setup=true"

import "./LotMatcher.vue?vue&type=style&index=0&id=4ca1b496&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca1b496"]])

export default __exports__